/*
 *
 * BackbookUserNotRegisteredModal
 *
 * @version 1.0.0
 * @author Patrizia Petrera
 * @since 17-Oct-2024
*/

import BackbookUserNotRegisteredModal from './BackbookUserNotRegisteredModalContainer'

export default BackbookUserNotRegisteredModal
